import ProductLoanActionTypes from './product-loan-proposal.types';

/** ***************** ADD PRODUCT DETAILS START *********************** */
export const addProductLoanProposalStart = (addData: any) => ({
	type: ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_START,
	payload: addData,
});

export const addProductLoanProposalSuccess = (successData: any) => ({
	type: ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addProductLoanProposalFailure = (failureData: any) => ({
	type: ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addProductLoanProposalResponseResetStart = () => ({
	type: ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addProductLoanProposalResponseChanged = () => ({
	type: ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** ADD PRODUCT DETAILS END *********************** */

/** ***************** UPDATE PRODUCT DETAILS START *********************** */
export const updateProductLoanProposalStart = (addData: any) => ({
	type: ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_START,
	payload: addData,
});

export const updateProductLoanProposalSuccess = (successData: any) => ({
	type: ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateProductLoanProposalFailure = (failureData: any) => ({
	type: ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateProductLoanProposalResponseResetStart = () => ({
	type: ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateProductLoanProposalResponseChanged = () => ({
	type: ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** UPDATE PRODUCT DETAILS END *********************** */
